export const buildHostRegistrationRoute = () => '/register';
export const buildHostRegistrationHostFormRoute = () => `${buildHostRegistrationRoute()}/host`;
export const buildHostRegistrationPropertyFormRoute = () => `${buildHostRegistrationRoute()}/property`;
export const buildHostRegistrationSuccessRoute = () => `${buildHostRegistrationRoute()}/success`;

export const buildAwardsRoute = () => '/awards';
export const buildAwardsHostProfileRoute = hostId => hostId ? `${buildAwardsRoute()}/hostprofile/${hostId}` : `${buildAwardsRoute()}/hostprofile/:id`;

export const buildHostProfileListingRoute = () => '/hosts';
export const buildHostProfileRoute = hostId  => hostId ? `${buildHostProfileListingRoute()}/hostprofile/${hostId}` : `${buildHostProfileListingRoute()}/hostprofile/:id`;
